var _excluded = ["url", "path", "event_id", "uid", "track_id", "error_type", "error_level", "error_description", "error_extra"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import isClient from './util/detectClient';
import request from './util/request';
import configurable from './util/configurable';
import { getUserID, Config, trackID } from './util/config';
import { camelToUnder } from './util/json';
export var ERROR_TYPE = {
  // 静态文件
  STATIC_RESPOURSE: 1,
  // js报错
  JAVASCRIPT: 2,
  // 接口请求
  HTTP_REQUEST: 3,
  // 白屏
  PAGE_BLANK: 4,
  // 业务自定义报错
  BUSINESS: 5
};
export var ERROR_LEVEL = {
  // 紧急
  URGENT: 1,
  // 严重
  CRITICAL: 2,
  // 轻微
  MINIMAL: 3
};
var DEFAULT_ERROR_EVENT_ID = '8695928043431936';

/**
 * 错误上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */
var report = configurable(function (json, callback) {
  var _camelToUnder = camelToUnder(json),
    _camelToUnder$url = _camelToUnder.url,
    url = _camelToUnder$url === void 0 ? isClient ? location.href : '' : _camelToUnder$url,
    _camelToUnder$path = _camelToUnder.path,
    path = _camelToUnder$path === void 0 ? isClient ? location.pathname : '' : _camelToUnder$path,
    _camelToUnder$event_i = _camelToUnder.event_id,
    event_id = _camelToUnder$event_i === void 0 ? DEFAULT_ERROR_EVENT_ID : _camelToUnder$event_i,
    _camelToUnder$uid = _camelToUnder.uid,
    uid = _camelToUnder$uid === void 0 ? getUserID() : _camelToUnder$uid,
    _camelToUnder$track_i = _camelToUnder.track_id,
    track_id = _camelToUnder$track_i === void 0 ? trackID : _camelToUnder$track_i,
    error_type = _camelToUnder.error_type,
    error_level = _camelToUnder.error_level,
    error_description = _camelToUnder.error_description,
    error_extra = _camelToUnder.error_extra,
    rest = _objectWithoutProperties(_camelToUnder, _excluded);

  // 要上报的数据
  var errorData = _objectSpread({
    // 当前页面 URL
    url: url,
    path: path,
    // 登录用户 ID，用户登录后端写到 cookie 中
    uid: uid,
    event_id: event_id,
    // 错误类型
    error_type: error_type,
    // 错误等级
    error_level: error_level,
    // 错误描述
    error_description: error_description,
    // 其他信息
    error_extra: error_extra,
    track_id: track_id
  }, rest);
  request(Config.VERB)("".concat(Config.GS), errorData, callback);
}, {});
export default report;